import { Box, Button, Container, Grid, Paper, Popover, Snackbar, Table, TableBody, TableContainer, TableHead, TablePagination, Typography } from "@mui/material";
import React, { useEffect, useState, forwardRef, useRef } from "react";
import styles from '../../../styles.module.css';
import { useDispatch, useSelector } from "react-redux";
// import { editDeleteCharges, getChargesList } from "../../../../../actions/actions";
import { ActionMsg, AddButton, Breadcrumb, CustomePopover, DateConversionOnEntryPage, DeleteDialog, ExcelDownload, HandleCloseSnackbar, HandleSort, SearchInput, StyledTableCell, StyledTableRow, useMessageHandler } from "../../reusableComponent/Reusables";
// import { rows } from '../../masters/MastersFakeDb';
import { NavLink } from "react-router-dom";
import ProductionPlanningPrint from "./ProductionPlanningPrint";
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import EditIcon from '@mui/icons-material/Edit';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import PopupState, { bindPopover, bindTrigger } from "material-ui-popup-state";
import ReactToPrint from "react-to-print";
import { editDeleteProductionPlanning, getProductionPlanningList } from "../../../actions/actions";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";




// const ComponentToPrintRow = forwardRef((props, ref) => {
//     const { value } = props;
//     return (
//         <div className="print-source" ref={ref}>
//             <SalesOrderPrint salesOrderPrint={value} />
//         </div>
//     );
// });
// export { ComponentToPrintRow };
const ComponentToPrintWrapper = ({ quotationPrint }) => {
    const ref = useRef();
    return (
        <div style={{ display: "flex" }}>
            <ReactToPrint
                trigger={() => <span style={{ display: 'flex', justifyContent: 'center' }}> <PrintOutlinedIcon /> <span style={{ marginLeft: '22px' }}>  Print Record </span> </span>}
                content={() => ref.current}
            />
            <div style={{ display: 'none' }}>
                <ProductionPlanningPrint ref={ref} salesOrderPrint={quotationPrint} />
            </div>
        </div>
    );
};
// export { ComponentToPrintWrapper };
const ProductionPlanningList = () => {
    const dispatch = useDispatch();
    const login_details = sessionStorage.getItem('loginUser');
    const userD = JSON.parse(login_details);
    const userInfo = userD.userInfo; 

    const [isDelete, setIsDelete] = useState(false);
    const [deleteInfo, setDeleteInfo] = useState();
    const [sortBy, setSortBy] = useState(null);

    const rows = useSelector(state => state.production_planning.production_planning)
    const [searchKey, setSearchKey] = useState('');

    const fields = [
        'customer',
        'so_no',
        'issued_by',
        'approved_by',
        'delivery_by',
        'total_credit_limit',
        'gross_amount'
    ];

    const labels = [
        'Customer',
        'Sales Order No',
        'Issued By',
        'Approved By',
        'Delivery By',
        'Total Credit Limit',
        'Gross Amount'
    ];

    // const [successMessage, setSuccessMessage] = useState(null);
    // const respMsgState = 'test'
    // const respMsgState = useSelector((state) => state.charges.message);
  const [total_count,setTotalCount]=useState(null)
  useEffect(() => {
    setTotalCount(rows[0]?.totalCount);
  }, [rows]);
    const [controller, setController] = useState({
        page: 0,
        rowsPerPage: 10
    });

    const handleChangePage = (event, newPage) => {
        setController({
            ...controller,
            page: newPage
        });
    };

    const handleChangeRowsPerPage = (event) => {
        setController({
            ...controller,
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

    const fetchData = () => {
        const params = {
            page: controller.page,
            size: controller.rowsPerPage,
            searchKey: searchKey,
        }
        dispatch(getProductionPlanningList(params))
    };

    const handleSearch = (e) => {
        setSearchKey(e.target.value)
        const params = {
            page: controller.page,
            size: e.target.value === '' ? controller.rowsPerPage : (rows[0]?.total_count || 0),
            searchKey: e.target.value,
        }
        dispatch(getProductionPlanningList(params))
    }

    useEffect(() => {
        fetchData()
    }, [controller]);

    // const { shouldShowMsg, responseMessage } = useMessageHandler( null, setSuccessMessage, respMsgState);

    // useEffect(() => {
    // }, [shouldShowMsg, responseMessage,]);

    const deleteRecord = (id) => {
        dispatch(editDeleteProductionPlanning({ pp_id: id, changedUpdatedValue: 'delete' }))
        setIsDelete(false);
        fetchData()
    }

    const handleDelete = (functions) => {
        setIsDelete(true);
        setDeleteInfo(functions);
    }

    const handleClose = (event, reason) => {
        setIsDelete(false)
        setDeleteInfo(null);
    };
    console.log('data', rows)

    const [successMessage, setSuccessMessage] = useState(null);
            //const respMsgState = 'test'
            const respMsgState = useSelector((state) => state.production_planning.message);
    
            const { shouldShowMsg, responseMessage } = useMessageHandler(fetchData,null, setSuccessMessage, respMsgState);
                 useEffect(() => {
                        if (respMsgState) {
                            setSuccessMessage(respMsgState);
                        }
                    }, [respMsgState]);
                useEffect(() => {
                }, [shouldShowMsg, responseMessage,]);
    return (
        <>
            <Paper className={`${styles.cts_page}`}>
                <Breadcrumb
                    routeSegments={[
                        // { name: 'Dashbord', path: '/dashboard' },
                        { name: 'Production Planning List' },
                    ]}
                />
                <Box sx={{ display: 'flex' }}>
                    <Grid container spacing={2} sx={{ pt: 1.5, pb: 1.5 }}>
                        <Grid item md={7} sm={6} xs={12}>
                            <Box sx={{ display: 'flex' }}>
                                <Typography className={`${styles.form_title}`} >
                                    Production Planning List
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item md={5} sm={6} xs={12} sx={{ display: 'flex', justifyContent: 'space-between' }}>
                            <Box className={`${styles.excel_box}`}>
                                <ExcelDownload
                                    data={rows}
                                    fields={fields}
                                    labels={labels}
                                    filename="Production Planning List"
                                />
                            </Box>
                            <SearchInput
                                value={searchKey}
                                onChange={handleSearch}
                            />
                            <AddButton to="/productionEntries/add-pp" label="" />
                        </Grid>
                    </Grid>
                </Box>
                <TableContainer component={Paper} className={`${styles.list_tbl_container}`}>
                    <Table size="small" stickyHeader>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell align="center" className={`${styles.table_head}`}>Action</StyledTableCell>
                                <StyledTableCell align="Left" className={`${styles.table_head}`} onClick={() => HandleSort('pp_no', sortBy, setSortBy, rows)}>Production Planning No<span className={`${styles.sort_icon}`}> {sortBy === 'pp_no' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('prepared_by', sortBy, setSortBy, rows)}>Prepared By<span className={`${styles.sort_icon}`}> {sortBy === 'prepared_by' ? '▲' : '▼'} </span></StyledTableCell>
                                <StyledTableCell align="center" className={`${styles.table_head}`} onClick={() => HandleSort('pp_date', sortBy, setSortBy, rows)}>Production Planning Date<span className={`${styles.sort_icon}`}> {sortBy === 'pp_date' ? '▲' : '▼'} </span></StyledTableCell>
                            </StyledTableRow>
                        </TableHead>
                        <TableBody>
                            {Array.isArray(rows) && rows.map((row, index) => (
                                <StyledTableRow
                                    key={row.so_no}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                                    <StyledTableCell align="center">
                                        <CustomePopover row={row} handleDelete={false} linkTo="/productionEntries/add-pp" PrintComponent={ProductionPlanningPrint} />
                                    </StyledTableCell>
                                    <StyledTableCell align="left" className={`${styles.list_table_body}`}  
                                        //  to="/productionEntries/details-pp" state={row} className={`${styles.underline}`} style={{ color: 'blue', cursor: "pointer" }}>
                                           > {row.pp_no}
                                        
                                    </StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.prepared_by}</StyledTableCell>
                                    <StyledTableCell align="center" className={`${styles.list_table_body}`}>{row.pp_date}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    component="div"
                    onPageChange={handleChangePage}
                    page={controller.page}
                    count={rows && (rows[0]?.total_count || 0)}
                    rowsPerPage={controller.rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
                <DeleteDialog
                    open={isDelete}
                    handleClose={handleClose}
                    deleteInfo={deleteInfo}
                    deleteRecord={deleteRecord}
                    deleteID={deleteInfo?.pp_id || null}
                    displayName={deleteInfo?.pp_id || ''}
                />
                <ReusableSnackbar
                    open={!!successMessage}
                    onClose={(event, reason) => {
                        if (reason !== 'clickaway') {
                            setSuccessMessage("");
                        }
                    }}
                    message={successMessage}
                    autoHideDuration={2000}
                    vertical="top"
                    horizontal="right"
                />
            </Paper>
        </>
    )
}
export default ProductionPlanningList;